import { Service } from '@yleisradio/areena-types';

export type Section = Service | 'broadcasts' | 'search' | 'personal';

const broadcastPaths = [
  '/tv/opas',
  '/tv/guide',
  '/podcastit/opas',
  '/poddar/guide',
  '/suorat',
  '/direkt',
];

export const sectionFromPath = (path: string): Section | undefined => {
  if (broadcastPaths.some((broadcastPath) => path.startsWith(broadcastPath)))
    return 'broadcasts';

  if (path.startsWith('/tv')) return 'tv';

  if (path.startsWith('/podcastit') || path.startsWith('/poddar'))
    return 'radio';

  if (path.startsWith('/hae') || path.startsWith('/sok')) return 'search';

  if (path.startsWith('/omat') || path.startsWith('/mina')) return 'personal';

  return undefined;
};
